import OkvedPartitionList from 'components/Settings/Okved/okved-partition-list';
import OkvedGroupList from 'components/Settings/Okved/okved-group-list';
import { Box, Stack } from '@mui/material';
import { createContext, useState } from 'react';

interface OkvedContextType {
  selectedPartitionId: number | null;
  setSelectedPartitionId: (id: number | null) => void;
}

const OkvedContext = createContext<OkvedContextType | undefined>(undefined);


export const OkvedList = () => {
  const [selectedPartitionId, setSelectedPartitionId] = useState<number | null>(null);

  const handlePartitionSelect = (id: number) => {
    setSelectedPartitionId(id);
  };
  return (

    <OkvedContext.Provider value={{ selectedPartitionId, setSelectedPartitionId }}>
      <Stack direction='row' spacing={2} sx={{ width: '100%', height: '100%' }}>
        <Box sx={{ width: '50%', height: '100%' }}>
          <OkvedPartitionList         
            onPartitionSelect={handlePartitionSelect} 
            selectedPartitionId={selectedPartitionId}  />
        </Box>
        <Box sx={{ width: '50%', height: '100%' }}>
          <OkvedGroupList partitionId={selectedPartitionId} />
        </Box>
      </Stack>
    </OkvedContext.Provider>

  );
};

export default OkvedList;
